export const order = [
  {
    address: "*****",
    company: "",
    orderId: "230109-289994197801003",
    orderTime: "2023-01-09 14:09:24",
    phone: "****",
    productName: "TANJI高级文化衫【正直诚信】针织,女士款式",
    reciver: "*****",
    remark: "",
    status: false,
  },
  {
    address: "*****",
    company: "",
    orderId: "230109-461792889641003",
    orderTime: "2023-01-09 14:09:24",
    phone: "****",
    productName: "TANJI高级文化衫【正直诚信】针织,女士款式",
    reciver: "*****",
    remark: "",
    status: false,
  },
  {
    address: "*****",
    company: "",
    orderId: "221228-080095559221248",
    orderTime: "2022-12-28 15:37:30",
    phone: "****",
    productName: "TANJI高级文化衫【正直诚信】针织,女士款式",
    reciver: "*****",
    remark: "",
    status: false,
  },
  {
    address: "*****",
    company: "",
    orderId: "221228-014019542581248",
    orderTime: "2022-12-28 14:10:47",
    phone: "****",
    productName: "TANJI高级文化衫【正直诚信】针织,女士款式",
    reciver: "*****",
    remark: "",
    status: false,
  },
];
